<template>
  <base-section-layout
    title="EVUS 登记提醒"
    icon="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-evus.png"
  >
    <div class="section-text">
      <div>
        美国签证获签后，请务必在出行前完成 EVUS（签证更新电子系统）登记。
      </div>
      <div class="sub-content">
        持10年有效期
        B1/B2、B1或B2类美国签证的中国大陆护照持有人，出行前必须在EVUS系统完成登记并获得授权，未登记或登记未通过者将无法顺利登机入境。
      </div>
    </div>
  </base-section-layout>
</template>

<script>
import BaseSectionLayout from './BaseSectionLayout.vue';

export default {
  name: 'SectionEvusReminder',
  components: {
    BaseSectionLayout,
  },
};
</script>

<style lang="less" scoped>
.section-text {
  color: #666;
  font-size: 12px;
  line-height: 21px;
  word-break: break-all;

  .sub-content {
    margin-top: 6px;
    color: #a6a6a6;
  }
}
</style>
